import React, { lazy, useEffect, useState, Suspense, memo } from 'react';
import { Loader } from '@wix/calendar-client-library-v3';
import {
  getStyleParams,
  isEditorViewMode,
  resizeComponent,
  setHeight,
} from '../../../../utils';
const MonthlyCalendar = lazy(() => import('@wix/calendar-client-library-v3'));
// import MonthlyCalendar from '../localCalendars/components/containers/MonthlyCalendar/MonthlyCalendar'

const MonthlyWrapper = ({ calendarsProps }) => {
  const {
    isPreLoaded,
    calendarRef,
    isMobile,
    locale,
    isLiveSite,
  } = calendarsProps;

  const isEditor = isEditorViewMode();

  const [dimensions, setDimensions] = useState({
    // use for seting base size on component did mount, dont rewrite setDimensions values
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const isStretchable = getStyleParams()?.numbers?.cellResize === 1;
  const monthlyMobile = getStyleParams()?.numbers?.mobile_layoutIcons === 1;
  const monthlyDesktop = getStyleParams()?.numbers?.layoutIcons === 1;

  useEffect(() => {
    // resize on fullWith, without using fullWith just remove this useEffect
    const resize = () => {
      if (isEditor) {
        setTimeout(() => {
          const height = window.innerHeight;
          const width = window.innerWidth;
          let minHeight: number;
          let minWidth: number;

          if (!calendarsProps.isMobile) {
            minWidth = 550;
            minHeight = isStretchable ? 500 : width + 40;
            if (!isStretchable) {
              if (width - height > 100) {
                setHeight(calendarRef?.current?.scrollHeight);
              }
              if (height - width > 100) {
                setHeight(width);
              }
            }

            if (isMobile) {
              minWidth = 320;
              minHeight = 460;

              if (calendarRef?.current?.clientHeight) {
                minHeight = calendarRef?.current?.clientHeight;
              }
            }

            if (width < minWidth) {
              resizeComponent({ width: minWidth, height });
            }
            if (height < minHeight) {
              resizeComponent({ width, height: minHeight });
            }
          }
        }, 500);
      }
    };

    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [isStretchable, calendarRef?.current?.scrollHeight]);

  // useEffect(() => {
  //   // resize if minSize > current size
  //   const minHeightResize = debounce(() => {
  //     const height = window.innerHeight
  //     const width = window.innerWidth
  //     let minHeight: number
  //     let minWidth: number

  //     if (monthlyDesktop && !isMobile) {
  //       minWidth = 460
  //       minHeight = isStretchable ? 500 : window.innerWidth + 40

  //       if (!isStretchable && height - width > 40) {
  //         window.Wix.Settings.resizeComponent({ width, height: width + 40 })
  //       }
  //     }
  //     if (monthlyMobile && isMobile) {
  //       minWidth = 320
  //       minHeight = 460

  //       if (calendarRef?.current?.clientHeight) {
  //         minHeight = calendarRef?.current?.clientHeight
  //       }
  //     }
  //     if (width < minWidth) {
  //       resizeComponent(minWidth, height)
  //     }
  //     if (height < minHeight) {
  //       resizeComponent(width, minHeight)
  //     }
  //   }, 1000)

  //   window.addEventListener("resize", minHeightResize)
  //   return () => window.removeEventListener("resize", minHeightResize)
  // })

  useEffect(() => {
    // resize on componentDidMount
    setTimeout(() => {
      if (monthlyMobile && isMobile) {
        resizeComponent({
          width: window.innerWidth,
          height: calendarRef?.current?.clientHeight,
        });
      }

      if (monthlyDesktop && !isMobile) {
        if (!isStretchable) {
          if (
            window.innerWidth - window.innerHeight > 50 ||
            window.innerWidth < 460
          ) {
            setHeight(calendarRef?.current?.scrollHeight);
          } else if (window.innerHeight - window.innerWidth > 80) {
            setHeight(window.innerWidth);
          } else {
            setHeight(dimensions.height);
          }
          const isIncorrectRatio =
            window.innerWidth - window.innerHeight > 50 ||
            window.innerWidth < 460 ||
            window.innerHeight - window.innerWidth > 80;

          isIncorrectRatio
            ? resizeComponent({
                width: window.innerWidth,
                height: window.innerWidth + 40,
              })
            : setHeight(dimensions.height);
        } else {
          setHeight(dimensions.height);
        }
      }
    }, 500);
  }, [isStretchable, monthlyMobile, monthlyDesktop]);

  const handleCellSelect = () => {
    setTimeout(() => {
      if (calendarRef?.current) {
        setHeight(calendarRef.current.scrollHeight);
      }
    }, 100);
  };

  const updatetCalendarsProps = {
    ...calendarsProps,
    handleCellSelect,
  };

  return (
    <Suspense
      fallback={() => (
        <Loader
          isPreLoaded={isPreLoaded}
          locale={locale}
          isLiveSite={isLiveSite}
        />
      )}
    >
      {monthlyMobile && isMobile ? (
        <div>
          {<MonthlyCalendar calendarsProps={...updatetCalendarsProps} />}
        </div>
      ) : (
        <MonthlyCalendar calendarsProps={...updatetCalendarsProps} />
      )}
    </Suspense>
  );
};

export default memo(MonthlyWrapper);
